import { useState, useMemo, useCallback } from 'react';
import type { JobThread } from '../types/foreman';
import type { UserRole } from '../types/gateway';

// Mock threads for development — will be replaced by BuilderTrend sync
const MOCK_THREADS: JobThread[] = [
  {
    id: '1',
    name: 'Henderson Kitchen',
    code: 'KBW-2026-042',
    status: 'active',
    unread: 2,
    lastMessage: 'Scope submitted for pricing',
    lastMessageAt: new Date().toISOString(),
    role: 'designer',
  },
  {
    id: '2',
    name: 'Miller Master Bath',
    code: 'KBW-2026-039',
    status: 'attention',
    unread: 1,
    lastMessage: 'CO risk: tile waste factor may be low',
    lastMessageAt: new Date().toISOString(),
    role: 'designer',
  },
  {
    id: '3',
    name: 'Thompson Powder Room',
    code: 'KBW-2026-045',
    status: 'ready',
    unread: 0,
    lastMessage: 'Install pack generated',
    lastMessageAt: new Date().toISOString(),
    role: 'field',
  },
  {
    id: '4',
    name: 'Weekly AMX Audit',
    code: 'AUDIT-W07',
    status: 'active',
    unread: 3,
    lastMessage: '4 unmatched receipts flagged',
    lastMessageAt: new Date().toISOString(),
    role: 'accounting',
  },
];

export interface UseThreadsReturn {
  threads: JobThread[];
  filteredThreads: JobThread[];
  activeThreadId: string | null;
  setActiveThreadId: (id: string | null) => void;
}

export function useThreads(role: UserRole): UseThreadsReturn {
  const [threads] = useState<JobThread[]>(MOCK_THREADS);
  const [activeThreadId, setActiveThreadId] = useState<string | null>(null);

  const filteredThreads = useMemo(
    () => threads.filter((t) => t.role === role),
    [threads, role]
  );

  const handleSetActiveThread = useCallback((id: string | null) => {
    setActiveThreadId(id);
  }, []);

  return {
    threads,
    filteredThreads,
    activeThreadId,
    setActiveThreadId: handleSetActiveThread,
  };
}
